import { collection, doc, getDoc, setDoc, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchGedLink(linkId) {
  const linkRef = doc(collection(db, 'rda_ged_links'), linkId);
  const snap = await getDoc(linkRef);
  return snap?.exists && snap.exists() ? snap.data() || {} : {};
}

export async function saveGedLink(linkId, data) {
  const linkRef = doc(collection(db, 'rda_ged_links'), linkId);
  await setDoc(linkRef, { ...data, addedAt: serverTimestamp() }, { merge: true });
}

export async function addClientNote(appId, clientId, noteData) {
  const notesRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients', clientId, 'notes');
  await addDoc(notesRef, { ...noteData, createdAt: serverTimestamp() });
}
